<template>
  <v-row dense>
    <v-col cols="12" sm="5">
      <v-select
        :items="actions"
        filled
        dense
        placeholder="Actions sur la sélection"
        class="no-before"
        v-model="action"
        :hint="`${selected.length} produits sélectionnés`"
        persistent-hint
      ></v-select>
    </v-col>
    <v-col cols="12" sm="2">
      <v-btn
        color="success"
        height="40px"
        :disabled="action === null || selected.length < 1"
        @click="actionHandler"
        ><v-icon>fa-chevron-right</v-icon></v-btn
      >
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ProductBulkEditorActions",
  props: {
    selected: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      actions: [
        { value: "addTag", text: "Ajouter un mot clé" },
        { value: "setTag", text: "Remplacer les mots clés" },
        { value: "removeTag", text: "Retirer un mot clé" },
        { value: "addAllergen", text: "Ajouter un allergène" },
        { value: "removeAllergen", text: "Retirer un allergène" },
        { value: "delete", text: "Supprimer les produits" }
      ],
      action: null
    };
  },
  methods: {
    actionHandler() {
      switch (this.action) {
        case "addTag":
          this.addTag();
          break;
        case "removeTag":
          this.removeTag();
          break;
        case "setTag":
          this.setTag();
          break;
        case "addAllergen":
          this.addAllergen();
          break;
        case "removeAllergen":
          this.removeAllergen();
          break;
        case "delete":
          this.deleteProducts();
          break;
      }
    },
    async addTag() {
      const tag = await this.$dialog.prompt({
        text: "",
        title: "Mot clé à ajouter"
      });
      if (tag) {
        const formatedTag = this.formatTag(tag);
        this.selected.forEach(x => {
          x.is_changed = true;
          x.data.tags.push(formatedTag);
        });
      }
    },
    async setTag() {
      const tag = await this.$dialog.prompt({
        text:
          "Fournir une liste de mot clé séparé par des virgule. Ex: #viande,#soupe",
        title: "Remplacer les mots clés"
      });
      if (tag) {
        const tags = tag.split(",");
        tags.map(x => this.formatTag(x));
        this.selected.forEach(x => {
          x.is_changed = true;
          x.data.tags = tags;
        });
      }
    },
    async removeTag() {
      const tag = await this.$dialog.prompt({
        text: "",
        title: "Mot clé à retirer"
      });
      if (tag) {
        const formatedTag = this.formatTag(tag);
        this.selected.forEach(x => {
          x.is_changed = true;
          x.data.tags = x.data.tags.filter(x => x !== formatedTag);
        });
      }
    },
    async deleteProducts() {
      const confirm = await this.$dialog.confirm({
        text: "Voulez-vous vraiment supprimer les produits sélectionnés?",
        title: ""
      });
      if (confirm === true) {
        this.selected.forEach(x => {
          x.is_changed = true;
          x.is_deleted = true;
        });
      }
    },
    async addAllergen() {
      const allergen = await this.$dialog.prompt({
        text: "",
        title: "Allergène à ajouter"
      });
      if (allergen) {
        this.selected.forEach(x => {
          x.is_changed = true;
          x.data.allergens.push(allergen);
        });
      }
    },
    async removeAllergen() {
      const allergen = await this.$dialog.prompt({
        text: "",
        title: "Allergène à retirer"
      });
      if (allergen) {
        this.selected.forEach(x => {
          x.is_changed = true;
          x.data.allergens = x.data.allergens.filter(x => x !== allergen);
        });
      }
    },
    formatTag(v) {
      if (v.length > 0 && v.charAt(0) === "#") {
        return v;
      } else if (v.length > 0 && v.charAt(0) !== "#") {
        return `#${v}`;
      } else {
        return v;
      }
    }
  }
};
</script>

<style></style>
